import { render } from "./ResultPage.vue?vue&type=template&id=677edbf2&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=677edbf2&scoped=true&lang=scss"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677edbf2"]])

export default __exports__